<template>
  <section class="block-advantages advantages" :class="[device_platform]">
    <div class="container">
      <h2 class="advantages__title title">Наши преимущества</h2>
      <div class="advantages__list">
        <div class="arrow arrow-left" v-if="device_platform === 'mobile'"></div>
        <div
          class="arrow arrow-right"
          v-if="device_platform === 'mobile'"
        ></div>
        <div class="swiper-container advantages-swiper">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(a, index) in advantages"
              :key="index"
            >
              <div
                class="advantages__item"
                @click="getCall({ type: 'sale', form: 'advantages' })"
              >
                <img
                  :src="require('../images/icons/' + a.icon + '.png')"
                  :alt="a.icon"
                  class="advantages__icon"
                />
                <p class="advantages__text" v-html="a.text"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Mixin from "../common/mixin";
import Swiper from "swiper";

export default {
  name: "block-advantage",
  mixins: [Mixin],
  data() {
    return {
      swiper: null,
      advantages: [
        {
          icon: 1,
          text: "20 лет вместе<br> с вами",
        },
        {
          icon: 2,
          text: "Выкуп автомобиля до 100%<br> от рыночной стоимости",
        },
        {
          icon: 3,
          text: "Выдача<br> за 1 день",
        },
        {
          icon: 4,
          text: "2 года<br> гарантии",
        },
      ],
    };
  },
  mounted() {
    this.initSwiper();
  },
  watch: {
    device_platform() {
      if (this.swiper) {
        this.swiper.destroy();
        this.swiper = null;
        this.$nextTick(this.initSwiper);
      }
    },
  },
  methods: {
    initSwiper() {
      if (this.swiper) return;
      this.swiper = new Swiper(`.advantages-swiper`, {
        slidesPerView: "auto",
        loop: false,
        simulateTouch: false,
        navigation: {
          nextEl: `.arrow-right`,
          prevEl: `.arrow-left`,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "../styles/constants.scss";

.advantages {
  padding: 60px 0;

  &__title {
  }

  &__list {
    margin-top: 64px;
    position: relative;
  }

  .swiper-slide {
    width: 25%;
    min-width: 140px;
  }

  &__item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 24px;
    padding: 20px 0;
    border-right: 1px solid #b3b3b3;
    cursor: pointer;

    &:hover {
      .advantages__icon {
        transform: translateY(-5px) scale(1.1);
      }

      .advantages__text {
        color: $gray_dark;
      }
    }

    &:last-child {
      border: none;
    }
  }

  &__icon {
    transition: $transition;
  }

  &__text {
    font-size: 14px;
    line-height: 23px;
    text-align: center;
  }
}

@media (max-width: 640px) {
  .advantages {
    &__list {
      margin-top: 20px;
    }

    .swiper-slide {
      width: 100%;
    }

    &__item {
      border: none;
    }
  }
}
</style>
